import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  deleteSeasonRateRuleAsync,
  getSeasonRateMinimumLengthOfStayRuleAsync,
  selectMinimumLengthOfStayRuleDetails,
  selectMinimumLengthOfStayRuleDetailsLoadingStatus,
  updateSeasonRateMinimumLengthOfStayRuleAsync,
} from '../seasonRateRulesSlice';
import RateMinimumLengthOfStayForm from './RateMinimumLengthOfStayForm';
import { MinimumLengthOfStayRuleDetails } from '../../../common/types/rates.types';

function SeasonRateMinimumLengthOfStay({
  seasonRateId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const minimumLengthOfStayRuleDetails = useAppSelector(
    selectMinimumLengthOfStayRuleDetails,
  );
  const minimumLengthOfStayItemStatus = useAppSelector(
    selectMinimumLengthOfStayRuleDetailsLoadingStatus,
  );

  const initialData: MinimumLengthOfStayRuleDetails = {
    seasonRateId,
    minimumLengthOfStay: null,
    isActive: true,
    isCopyable: true,
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    dispatch(getSeasonRateMinimumLengthOfStayRuleAsync(seasonRateId));
  }, [dispatch, seasonRateId]);

  useEffect(() => {
    if (
      minimumLengthOfStayRuleDetails &&
      minimumLengthOfStayRuleDetails.seasonRateId === seasonRateId
    ) {
      setData(minimumLengthOfStayRuleDetails);
    } else {
      setData(initialData);
    }
  }, [minimumLengthOfStayRuleDetails]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setData(newData);
  };

  const onSubmit = () => {
    dispatch(updateSeasonRateMinimumLengthOfStayRuleAsync(data));
    setSubmitted(true);
  };

  const onDelete = () => {
    if (window.confirm('Haluatko varmasti poistaa säännön?')) {
      dispatch(deleteSeasonRateRuleAsync(data.id));
      setSubmitted(false);
      setData(initialData);
      setDeleted(true);
    }
  };

  return (
    <RateMinimumLengthOfStayForm
      loadingStatus={minimumLengthOfStayItemStatus}
      handleInputChange={handleInputChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitted={submitted}
      deleted={deleted}
      data={data}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRateMinimumLengthOfStay;
